import { gql } from "@apollo/client";

export const GET_PROFILE = gql`
  query getProfile {
    getProfile {
      user {
        fireBasePhone,
        contact_id
        objectUserId,
        id,
        firstName,
        lastName,
        image,
        countryCode,
        phone,
        email,
        channelFoundUs,
        isEmailConfirmed,
        isDuplicateAccount,
        location {
          idLocation,
          timeZone,
          isOnlyUrgentVisit,
          locationName,
          address,
          status,
          city,
          placeId,
          position {
            lat,
            lng,
          },
          email,
          phoneNumber,
          background,
        },
        isVetCoveRedirectDismissed,
        placeId,
        address,
        addressInfo {
          streetAddress,
          townCity,
          zipCode,
          country,
        },
      },
      success,
      messages,
    }
  }`;
